package streetlight.web.ui

import streetlight.model.ui.StarRoute
import streetlight.web.model.RouteDockState
import koala.modifier.*
import koala.dom.*
import koala.html.btn
import koala.model.NullContent
import kotlinx.css.LinearDimension
import kotlinx.css.fr
import streetlight.model.data.Star
import streetlight.model.ui.ProfileConfigRoute
import streetlight.model.ui.HomeRoute
import streetlight.model.ui.GalaxyListRoute
import streetlight.model.ui.SandboxRoute
import streetlight.model.ui.StarDashRoute
import streetlight.web.model.SessionClient
import streetlight.model.ui.toRoute

fun ViewScope.viewStarDash(star: Star) {
    mainBody("viewStarDash.kt") {
        lazyTabs {
            tab("activity") {
                activityContent(star)
            }
            tab("sandbox") {
                sandboxContent(star)
            }
        }
    }

    dock.mergeState(StarDashRoute, RouteDockState(listOf(StarRoute(star.username)), title = star.username.value))
}

fun RouteScope.viewStarDashRoute() {
    routeBlock<StarDashRoute, NullContent>() {
        starGate { star ->
            viewStarDash(star)
        }
    }
}

private fun ViewScope.activityContent(star: Star) {
    grid {
        section("galaxies") {
            dataBlock(api.galaxy::readUserGalaxies) { galaxies ->
                galaxies.forEach { galaxy ->
                    grid(columnsOf(1.fr, LinearDimension.auto)) {
                        navigation(galaxy.toRoute()) {
                            // listingOf(galaxy.name, galaxy.image?.thumb)
                        }
                        // starToggle(galaxy.isLit, galaxy.galaxyId)
                    }
                }
            }
        }
        section("edits") {
            dataBlock(api.star::readPendingEdits) { logs ->
                logs.forEach { log ->
                    val label = log.recordEdit?.label ?: return@forEach
                    // listingOf(label, log.recordEdit?.image?.thumb)
                }
            }
        }
//        val dialog = dialog()
//        section("requests") {
//            dataBlock(api::readUserTasks) { tasks ->
//                tasks.forEach { task ->
//                    textBlock(task.label).onClick {
//                        dialog.updateContent(task.label, true) {
//                            dialogCard {
//                                taskContent(task)
//                            }
//                        }
//                    }
//                }
//            }
//        }
    }
}

private fun ViewScope.sandboxContent(star: Star) {
    // val model = UserHub(renderScope, app.client.api)
    val gate = app.get<SessionClient>()

    column {
        row {
            textBlock("Hello ${star.username}!", Flex1)
            button("go home", onClick = { portal.go(HomeRoute) })
            button("sign out", onClick = gate::signOut)
        }

        card {
            row {
                textBlock("Add things to the map.", Flex1)
                btn("Edit Profile", ProfileConfigRoute)
                btn("Go to sandbox", SandboxRoute)
                button("galaxy list", { portal.go(GalaxyListRoute) }, Accent)
            }
        }

//        card {
//            row {
//                textBlock("Share and grow your talents.", modify(Flex1))
//                button("add talent", { portal.go(EditTalentRoute()) }, modify(Accent))
//            }
//        }

//        itemsBlock(userCache.talent.flow) { talent ->
//            navigation(TalentProfileRoute(talent.talentId)) {
//                card {
//                    textBlock(talent.name)
//                }
//            }
//        }
    }
}